<div class="align-center">
  @if (data.type =='MODAL') {
    <div>
      <div class="modal-title-row">
        <h2 mat-dialog-title class="font-bold">{{content.title}}</h2>
        @if ((isScreenSmall | async)) {
          <mat-icon class="banner-close-icon" (click)="CloseDialog()">clear</mat-icon>
        }
      </div>
      <span mat-dialog-content [innerHtml]="content.htmlContent">
      </span>
      <mat-dialog-actions  fxLayout="row" fxLayoutAlign="center">
        <button mat-flat-button color="primary" (click)="loadNext()">Ok</button>
      </mat-dialog-actions>
    </div>
  }
  @if (data.type =='BANNER') {
    <div>
      <div class="clindx-carosel">
        <ngx-slick-carousel class="clindx-slide" #slickModal [config]="slickConfig">
          @for (slide of slidesContainer; track slide; let i = $index) {
            <ng-container ngxSlickItem>
              <div class="slide-item">
                <div class="slide-title">
                  <div class="slide-title-content">
                    <h2>{{slide.title}}</h2>
                    <p>{{slide.publishFromDate | date:'fullDate'}} - {{slide.publishToDate | date:'fullDate'}}</p>
                  </div>
                  @if ((isScreenSmall | async)) {
                    <mat-icon class="banner-close-icon" (click)="CloseDialog()">clear</mat-icon>
                  }
                </div>
                <div class="slide-divider"></div>
                <div class="slide-content" [innerHTML]="slide.htmlContent"></div>
              </div>
            </ng-container>
          }
        </ngx-slick-carousel>
      </div>
    </div>
  }
</div>
